/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "duyha",
  title: "Hello! I'm Duy",
  subTitle: emoji(
    "A Software Engineer specializing in Data Science. Dedicated to building innovative systems using machine learning, algorithms, and data structures."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1zDcWSU9U1PF043K-1BWGzkAiG9b38hgk/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/duy-ha-dev",
  linkedin: "https://www.linkedin.com/in/duy-hoang-ha/",
  gmail: "duyh77686@gmail.com",
  // gitlab:
  // facebook:
  // medium:
  // stackoverflow:
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Who I am",
  subTitle:
    "Full-Stack Software Engineer with a Passion for AI Applications and Research",
  skills: [
    {
      skill: "Full Stack Software Engineering",
      description: emoji(
        "🖥️ designing, developing, and optimizing software solutions across mobile and web tech stacks through innovative features and integrations."
      )
    },
    {
      skill: "Algorithm Development & Optimization",
      description: emoji(
        "🧩 creating and refining algorithms for high-performance data processing and analysis in both research and industrial settings."
      )
    },
    {
      skill: "Advanced Machine Learning Techniques",
      description: emoji(
        "🤖 utilizing machine learning methods to analyze complex datasets for insightful research and practical applications."
      )
    }
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    // {
    //   skillName: "TypeScript",
    //   fontAwesomeClassname: "fi fi-brands-typescript"
    // },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "R",
      fontAwesomeClassname: "fab fa-r-project"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Rice University",
      logo: require("./assets/images/riceLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      subHeader2: "Minor in Data Science",
      duration: "August 2020 - May 2024",
      desc: "Took courses about Software Engineering, Operating Systems, Machine Learning, Bioinformatics, Computer Vision, and more! Relevant coursework by used languages:",
      descBullets: [
        {
          heading: "Python",
          item: "Algorithms & Data Structures, Machine Learning, Machine Learning w/ Graphs, Data Science Capstone, Quantum Computing (Qiskit), Computer Vision, Advance 3D Vision, Genomic-scale Algorithms"
        },
        {
          heading: "R",
          item: "Stats for Data Science, Tools and Models for Data Science, Data Visualization"
        },
        {
          heading: "C",
          item: "Fundamentals of Computer Engineering, Computer Systems, OS/Concurrent Programming, Compiler Construction"
        },
        {
          heading: "Java",
          item: "Program Design, Advance Object-Oriented Programming"
        }
      ]
    },
    {
      schoolName: "Northeast Lakeview College",
      logo: require("./assets/images/nlcLogo.png"),
      subHeader: "Associate of Liberal Arts",
      duration: "August 2016 - May 2020",
      desc: "Attended Northeast Lakeview College as part of a dual-enrollment program at Judson Early College Academy, where I achieved Valedictorian and became a recipient of the Texas Distinguished Level of Achievement. I focused on an advanced math specialization, successfully completing coursework from College Pre-Calculus through Calculus 2"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend & Design", //Insert stack or technology you have experience in
      progressPercentage: "55%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    },
    {
      Stack: "Machine Learning & Data Analysis",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      company: "Google",
      companylogo: require("./assets/images/googleLogo.png"),
      positions: [
        {
          role: "Software Engineer",
          date: "June 2024 - Present",
          desc: "Google Play | Atlanta GA",
          descBullets: [
            "Currently leveraging AI/ML to drive cutting-edge automation and optimization solutions for Play and YouTube 😊"
          ]
        },
        {
          role: "Software Engineering Intern",
          date: "May 2023 – August 2023",
          desc: "Fi Connectivity | Mountain View CA",
          descBullets: [
            "Designed and implemented new measurement library within Google Fi application using open-source networking stack Cronet to more accurately gauge users’ network performance by means of zero-rating throughput and latency estimations",
            "Documented comprehensive accuracy analysis of WiFi and cellular quality metrics by integrating a network connectivity assessment into an experimental Android application and comparing with the existing test methodology",
            "Improved approximation error on high-traffic (> 10Mbps) packets by 120% from existing throughput measurements",
            "Utilized Java/Kotlin dependency injections, async, futures, and multithreading to deliver Android client features"
          ]
        },
        {
          role: "Software Engineering (STEP) Intern",
          date: "May 2022 – August 2022",
          desc: "Ads Surfaces | Mountain View CA",
          descBullets: [
            "Worked closely with the team to improve overall advertiser accessibility by extending functionalities of a full stack web application through several Google infrastructures",
            "Delivered several launch-blocking UI features using frontend Closure Templates and HTML/Sass through collaboration with UX designer and frontend engineers",
            "Implemented read/write connection between Google F1 DB and Search backend using Java and Guice dependency injection",
            "Received team recognition through a Google Peer Bonus for conducting exceptional progress toward product launch"
          ]
        }
      ]
    },
    {
      company: "McGovern Medical School",
      companylogo: require("./assets/images/uthealthLogo.png"),
      positions: [
        {
          role: "Undergrad Research Assistant",
          date: "September 2023 - June 2024",
          desc: "Do Monte Lab | Houston TX",
          descBullets: [
            "Contributed to a forthcoming publication, providing key insights into neural mechanisms of emotional memory and reward processing",
            "Utilized autoencoder method CEBRA to compress and analyze time-series data, revealing critical patterns in neural activity related to emotional memory circuits",
            "Conducted computational analysis of neural representations of reward and fear behaviors to gain a broader understanding of prefrontal cortex neuron regulation in emotional responses",
            "Implemented advanced data preprocessing techniques to enhance the quality and accuracy of neural data analysis"
          ]
        }
      ]
    },
    {
      company: "Rice Networks Group",
      companylogo: require("./assets/images/rngLogo.png"),
      positions: [
        {
          role: "EECS Research Intern",
          date: "May 2021 - August 2021",
          desc: "NSF REU | Houston TX",
          descBullets: [
            "Improved building process of the Autonomous, Sensing, Tetherless Networked Drones (ASTRO) platform",
            "Designed and implemented drone mission codes for autonomous experimentation",
            "Utilized RENEWLab open-source mMIMO toolbox and experimented beamforming on ASTRO drones"
          ]
        }
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on
// Project asset links for the extra information section
const genieProblemExample = require("./assets/images/genieProblemExample.png");
const genieArchitecturalDesign = require("./assets/images/genieArchitecturalDesign.png");
const genieHighLevelDesign = require("./assets/images/genieHighLevelDesign.png");
const d2kPipeline = require("./assets/images/d2kPipeline.png");
const bigProjects = {
  title: "My Projects",
  subtitle: "Click on a project card for more info!",
  projects: [
    {
      projectName: "Computational Modeling of Reward- and Fear-Behaviors",
      projectDesc: "Bioinformatics, Machine Learning, Research",
      image: require("./assets/images/domonteProject.png"),
      footerLink: [
        {
          name: "Do Monte Lab",
          url: "https://sites.google.com/view/domontelab/home?authuser=0/"
        },
        {name: "CEBRA", url: "https://cebra.ai/"}
      ],
      categories: ["Bioinformatics", "Machine Learning", "Research"],
      extraInformationHtml: `<h3>Project information</h3>
      <ul>
        <li><strong><a href="https://sites.google.com/view/domontelab/home?authuser=0/">Do Monte Lab</a></strong></li>
        <li><strong>Fall 2023 - Summer 2024</strong></li>
        <li><strong>Research Trainee</strong></li>
      </ul>
      <p> 
        The project aims to deepen our understanding of the neural mechanisms underlying emotional memory and behavioral responses.
        In this project, I applied advanced machine learning techniques, such as <a href = "https://cebra.ai/"> CEBRA</a>, to compress and analyze
        complex time-series data from neural activity recordings. The approach revealed critical patterns within emotional memory circuits, 
        contributing valuable insights into how these circuits function. Additionally, I conducted computational analysis of prefrontal
        cortex neuron activity during reward and fear behaviors to elucidate the brain's processing of these stimuli. We can expect these findings 
        to be featured in an upcoming publication.
      </p>`
    },
    {
      projectName:
        "Genomic Expression Navigation and Integration Engine (GENIE): A Genomic Read Mapper",
      projectDesc: "Bioinformatics, Software Engineering",
      image: require("./assets/images/genieProject.png"),
      categories: ["Bioinformatics", "Engineering", "Software Engineering"],
      extraInformationHtml: `<h3>Project information</h3>
      <ul>
        <li><strong>Rice University CS Capstone</strong></li>
        <li><strong>Fall 2023</strong></li>
      </ul>
      <h3>A Very Fast Genomic Short Read Mapper</h3>
      <img src="${genieProblemExample}" alt="Fast Short Read Mapper Problem" style="max-width: 100%; height: auto;">

      <p>
        Read mapping is a fundamental task in computational biology, relevant to reference-guided assembly, 
        variant calling, and gene expression analysis. It became popularized in 2003 through the Human Genome Project, 
        which studied high-throughput mapping methods, costing about $3 billion over 13 years. 
        Read mapping involves aligning huge numbers of very short DNA sequences, or reads, to a reference genome. 
        This is a challenging task because the reads are often incomplete and may contain errors. 
        After preprocessing and alignment, reads must be mapped back to a reference genome to determine their origin. 
        Our project aims to develop a cost-effective and time-efficient mapping method that 
        accurately maps reads to complete gene expressions.
      </p>
      <p> 
        Addressing these challenges, we introduce GENIE (Genomic Expression Navigation and Integration Engine), 
        a Python package designed to revolutionize the process of read mapping. GENIE offers a systematic approach 
        to perform precise mapping of genomic reads, a cornerstone task in computational biology. 
        GENIE is tailored to provide a cost-effective and time-efficient solution, enabling precise mapping of 
        reads to complete gene expressions. By leveraging advanced algorithms and user-friendly interfaces, 
        GENIE aims to simplify and enhance the accuracy of read mapping, making it a valuable tool in the arsenal of 
        computational biology and genomic research.
      </p>

      <h3>Architectural Design</h3>
      <img src="${genieArchitecturalDesign}" alt="GENIE Architectural Design" style="max-width: 100%; height: auto;">

      <h3>High-Level Design</h3>
      <img src="${genieHighLevelDesign}" alt="GENIE High-Level Design" style="max-width: 100%; height: auto;">

      <h3>Results</h3>
      We achieved near-industry-standard performance
      in a short amount of time. Top performing short read mappers handle around 5-6 million RPM; 
      we were able to achieve 4 million RPM with memory optimization and high (~90%) precision/recall.`
    },
    {
      projectName:
        "DREAM-R: Dimensionality Reduction, Feature Extraction, and Modeling for RNA Transcriptome Data",
      projectDesc:
        "Bioinformatics, Machine Learning, Research, Software Engineering",
      image: require("./assets/images/d2kProject.png"),
      footerLink: [
        {
          name: "Poster",
          url: "https://drive.google.com/file/d/1Bee0JLybhYx0YYEflIfsoBEqgl5gMK0D/view?usp=sharing"
        },
        {
          name: "Sponser",
          url: "https://www.bcm.edu/people-search/rinki-ratnapriya-29180"
        },
        {name: "Rice D2K", url: "https://d2k.rice.edu/"}
      ],
      categories: [
        "Bioinformatics",
        "Machine Learning",
        "Research",
        "Software Engineering"
      ],
      extraInformationHtml: `<h3>Project information</h3>
      <ul>
        <li><strong>Rice D2K Project</strong></li>
        <li><strong>Fall 2023</strong></li>
      </ul>

      <p>
        In collaboration with Baylor College of Medicine, this project aims to address the complex nature of 
        Age-related Macular Degeneration (AMD) by utilizing machine learning to identify key genomic signatures associated with the disease. 
        This is crucial given the multifactorial causes of AMD, which include genetic variants, environmental stress, and aging. 
        Despite advances in treatments like Macugen and Photodynamic Therapy (PDT), 
        a comprehensive understanding of the disease at the genetic level is still lacking.
      </p>
      <h3>Package Pipeline</h3>
      <img src="${d2kPipeline}" alt="Data Science Pipeline for DREAM-R" style="max-width: 100%; height: auto;">
      <p> 
        This Python package offers a systematic approach to create machine-learning models that can classify patients into different stages of diseases. 
        The package not only aims to provide a versatile toolset for AMD but also for genomic analysis of other complex diseases. 
        This package includes comprehensive functionalities for data processing, feature selection, and model evaluation, thereby serving as a 
        robust platform for genomic data analysis in various applications.
      </p>`
    },
    {
      projectName: "Turning the Tides: Predicting Victory in League of Legends",
      projectDesc: "Machine Learning",
      image: require("./assets/images/lolProject.png"),
      footerLink: [
        {
          name: "Full Report",
          url: "https://drive.google.com/file/d/1E4X_gmj6Sd6yg_iVAhGjg0HbJmw1NO9z/view?usp=sharing"
        },
        {
          name: "Kaggle Dataset",
          url: "https://www.kaggle.com/datasets/bobbyscience/league-of-legends-diamond-ranked-games-10-min"
        }
      ],
      categories: ["Machine Learning"],
      extraInformationHtml: `<h3>Project information</h3>
      <ul>
        <li><strong>Personal Project</strong></li>
        <li><strong>Fall 2022</strong></li>
      </ul>

      <h3> Context and Motivation </h3>
      <p>
        League of Legends (LoL) is a strategic multiplayer game where two teams of five players each aim to destroy the enemy’s Nexus. 
        Players control "champions" with unique abilities. After years of playing, I've developed a gut feeling for predicting match outcomes around the 25-minute mark. 
        But what if we could predict the winner using data alone? Since teams can surrender as early as 15 minutes in, 
        having this insight could save me time (and as a result, improve my mental and energy).
      </p>

      <h3> Dataset and Objective </h3>
      <p>
        We're using the "high_diamond_ranked_10min" dataset from Kaggle, with 10,000 matches and 40 features. Each match has a set of 19 team-based features 
        collected after 10 minutes of play, and we're focused on Diamond-ranked solo queue games, where players have similar experience levels. This analysis 
        ignores champion picks to avoid issues with game updates and focuses solely on global variables. No data is missing.
      </p>

      <h3> Results </h3>
      <p>
        Our models achieved over 70% accuracy but struggled to exceed 75%, even after hyperparameter tuning. This may be due to high feature correlations, 
        such as the interplay between gold and experience, which complicates isolating the true impact of specific features.
      </p>

      <h3> Improving Model Performance </h3>
      <p>
        While the dataset is rich, it lacks crucial details about specific champions. Including champion data could enhance our models by allowing analysis 
        of team compositions and champion scalability, potentially improving accuracy. However, this would also introduce significant complexities in 
        data preparation and model training. Despite this, I think that predicting over 70% of match outcomes within the first 10 minutes is still impressive.
      </p>

      <h3> For the Players </h3>
      <p>
        Gold difference is the most critical early-game factor in predicting a win. 
        It's crucial to prioritize gaining gold and experience over risky objectives, 
        as early-game performance strongly influences the game's outcome.
      </p>`
    },
    {
      projectName: "EIC Lab: Efficient Machine Learning Toolbox",
      projectDesc: "Machine Learning, Research",
      image: require("./assets/images/emltProject.png"),
      footerLink: [
        {name: "EIC Lab", url: "https://eiclab.scs.gatech.edu/"},
        {
          name: "Project Github",
          url: "https://github.com/duy-ha-dev/PolarizationPruning"
        },
        {
          name: "Pruning & Polarization Regularizer Paper",
          url: "https://papers.nips.cc/paper/2020/file/703957b6dd9e3a7980e040bee50ded65-Paper.pdf"
        }
      ],
      categories: ["Machine Learning", "Research"],
      extraInformationHtml: `<h3>Project information</h3>
      <ul>
        <li><strong>Personal Research Project</strong></li>
        <li><strong>Summer 2021</strong></li>
      </ul>
    <p>
      In collaboration with Rice University's (now Geoergia Tech's) Efficient and Intelligent Computing Lab (EIC), 
      I contributed to the development of the Efficient Machine Learning Toolbox (EMLT) by implementing and fine-tuning a novel neuron pruning and polarization regularizer. 
      This technique aims to enhance the efficiency and performance of deep learning models by selectively pruning less important neurons, thereby reducing model complexity without significant loss in accuracy.
    </p>
    <p>
      I utilized PyTorch and CUDA to establish my local environment for conducting extensive experiments with the polarization regularizer. 
      This relatively new pruning technique shows promise in maintaining or even improving model performance while significantly reducing computational resources. 
      My work involved a deep dive into the underlying mathematics and implementation details of the pruning technique.
    </p>
    <p>
      Throughout the project, I drew upon the EMLT source code as a foundational reference. 
      My experimentation with various model architectures and hyperparameters provided key insights into the regularizer's impact on different types of neural networks. 
      This research project contributes to the broader goal of making machine learning more efficient and accessible, particularly in environments with limited computational power.
    </p>`
    },
    {
      projectName: "RNG Lab: Autonomous Drones and Massive MIMOs",
      projectDesc: "Engineering, Networking, Research, Software Engineering",
      image: require("./assets/images/astrosProject.png"),
      footerLink: [
        {name: "RNG Lab", url: "https://networks.rice.edu/"},
        {name: "ASTRO Project", url: "https://astro.rice.edu/"},
        {
          name: "RENEWLab Open Source",
          url: "https://github.com/renew-wireless/RENEWLab"
        },
        {name: "Project Github", url: "https://github.com/duy-ha-dev/RENEWLab"}
      ],
      categories: [
        "Engineering",
        "Networking",
        "Research",
        "Software Engineering"
      ],
      extraInformationHtml: `<h3>Project information</h3>
      <ul>
        <li><strong>REU Research Internship</strong></li>
        <li><strong>Summer 2021</strong></li>
      </ul>
      <p>
        During my REU Research Internship with Rice Networks Group (RNG), I had the opportunity to work closely with the ASTRO platform, 
        an initiative focused on autonomous drones and massive MIMO (Multiple-Input Multiple-Output) systems. As a research assistant, my first task was to streamline and update outdated documentation, 
        which significantly improved the build process using our lab’s resources.
      </p>
      <p>
        Under the guidance of a graduate student and in collaboration with the RENEW project, I delved into novel signal processing techniques. We conducted experiments using RENEW's Argos system, 
        which involved detecting isolated beamforming activities in autonomous drones. This project not only deepened my understanding of advanced signal processing and MIMO systems 
        but also gave me practical experience in adapting and optimizing complex software systems for research in autonomous technologies. This project's container provides links to the project 
        repository and RENEWLab's open-source code that we utilized throughout our experiments.
      </p>`
    },
    {
      projectName: "Website Design & Server Management",
      projectDesc: "Networking, Software Engineering, Web Development",
      image: require("./assets/images/websiteProject.png"),
      footerLink: [
        {
          name: "Legacy Website Github",
          url: "https://github.com/duy-ha-dev/Portfolio-Website"
        },
        {
          name: "Open Source developerFolio",
          url: "https://github.com/saadpasta/developerFolio"
        }
      ],
      categories: ["Networking", "Software Engineering", "Web Development"],
      extraInformationHtml: `<h3>Project information</h3>
      <ul>
        <li><strong>Personal Project</strong></li>
        <li><strong>Winter 2020 - Present</strong></li>
      </ul>

      <h3>Original Website 2020</h3>
      <p>
        In collaboration with two friends, we started creating and managing our personal websites using a Virtual Private Server hosted by Vultr. 
        We chose Debian as the operating system for our VPS and set up our web server using nginx. To enhance security, we implemented SSH key pairs. 
        Each of us hosted our respective websites via virtual hosting, with my domain secured through Epik. This initial phase laid the foundation for my web development journey.
      </p>

      <h3>Website Overhaul 2022</h3>
      <p>
        During the summer of 2022, I undertook significant renovations of my portfolio website. Leveraging wireframing techniques and the Bootstrap framework, I redesigned the site to 
        improve both its aesthetic appeal and user experience. This overhaul allowed me to sharpen my frontend development skills and provided an opportunity to experiment with modern design practices. 
        The most recent update to the site was completed on 12/21/2022.
      </p>

      <h3>Current Development 2024</h3>
      <p>
        This website you are viewing is the current state of my portfolio using the developerFolio template, an open-source solution designed for developers. 
        This phase involves extensive use of React and JavaScript, enabling me to create a more dynamic and interactive user experience. By integrating these technologies, 
        I am able to enhance the functionality and performance of the website. The ongoing development also serves as a platform for me to explore more advanced web development concepts and frameworks.
      </p>`
    },
    {
      projectName: "Portable IV Stand",
      projectDesc: "Engineering",
      image: require("./assets/images/ivStandProject.png"),
      footerLink: [
        {
          name: "Project Documentation",
          url: "https://rice.digication.com/duy-h/engi-120-220"
        }
      ],
      categories: ["Engineering"],
      extraInformationHtml: `<h3>Project information</h3>
      <ul>
        <li><strong>Engineering Design</strong></li>
        <li><strong>Fall 2020</strong></li>
      </ul>

      <h3>Team IV League</h3>
      <p>
        With three other student teammates and a design mentor, we developed an intuitive and portable IV stand, strictly following the Engineering Design Process. 
        Our client was the Barretos Cancer Hospital, Brazil's most advanced oncological hospital. The hospital needs cost-efficient and portable IV stands to treat at-home patients. 
        IV League's final design utilizes durable and cheap materials such as HDPE and aluminium. Along with functioning like a hospital-grade IV stand, it weighs 3.2kg and fits within 1.82 cubic foot when compressed.
      </p>`
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements and Certifications"),

  achievementsCards: [
    {
      title: "Algorithmic Toolbox Certificate",
      subtitle:
        "Earned through UCSD's Data Structures and Algorithms Specialization. Gained hands-on experience with advanced algorithms and data structures, applicable to real-world industry challenges.",
      image: require("./assets/images/ucsdLogo.png"),
      imageAlt: "The University of California at San Diego Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/DD64B43ZTFB6/"
        },
        {
          name: "Course",
          url: "https://www.coursera.org/learn/algorithmic-toolbox"
        }
      ]
    },
    {
      title: "The Gates Scholarship",
      subtitle:
        "Among 300 nationwide applicants to receive this full-ride scholarship for outstanding, minority, high school seniors from low-income households. ",
      image: require("./assets/images/tgsLogo.png"),
      imageAlt: "The Gates Scholarship Logo",
      footerLink: [
        {
          name: "Scholarship Site",
          url: "https://www.thegatesscholarship.org/"
        },
        {
          name: "Local News Coverage!",
          url: "https://news4sanantonio.com/news/local/judson-isd-student-awarded-prestigious-gates-scholarship"
        },
        {
          name: "Thank You Letter",
          url: "https://www.linkedin.com/pulse/thank-you-tgs-duy-ha/?trackingId=lSoDi%2BESCfpiEakQIn0l8w%3D%3D"
        }
      ]
    },
    {
      title: "QuestBridge College Match Finalist",
      subtitle:
        "Received the QuestBridge National College Match and admitted to Rice University with a full-ride scholarship. Awarded to students who has excelled academically despite financial hardship.",
      image: require("./assets/images/questbridgeLogo.png"),
      imageAlt: "QuestBridge Logo",
      footerLink: [
        {
          name: "Program Site",
          url: "https://www.questbridge.org/"
        }
      ]
    },
    {
      title: "City of San Antonio MLK Scholarship",
      subtitle:
        "Issued by the San Antonio Martin Luther Kink Jr. Commission. Recognizes strong commitment to human rights, equal educational opportunity, and economic well-being for all.",
      image: require("./assets/images/sanAntonioLogo.png"),
      imageAlt: "City of San Antonio Logo",
      footerLink: [
        {
          name: "Scholarship Site",
          url: "https://www.sa.gov/Directory/Departments/CE/Special-Events/MLK/Scholarships-and-Contests/Scholarship"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact"),
  subtitle: "Please feel free to reach out 😊!"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  resumeSection
};
